import React from "react";
import { withTranslation } from "react-i18next";
import { Button, Grid } from "@mui/material";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import PropTypes from "prop-types";
import { get } from "lodash";

import SelectField from "Components/Common/SelectField";
import InputFieldText from "Components/Common/InputFieldText";
import { getOptionValue } from "common/enums";

import { onlyNumberKeys } from "utils";

import { useAccessoriesQuery } from "apis/Accessories";
import { useMeasurementTypeQuery } from "apis/MeasurementType";

const RefundApplicationItem = ({
  accessoriesIndex,
  isDisabled,
  keyName,
  t,
  formik,
}) => {
  const { data: { data: accessoriesData = [] } = {} } = useAccessoriesQuery({
    utilityId: getOptionValue("utilityOptions", "Power"),
  });

  const { data: { data: { items: measurementTypes } = {} } = {} } =
    useMeasurementTypeQuery();

  const { setFieldValue, setFieldTouched, values } = formik;

  const handleRemoveClick = (i) => {
    setFieldValue(
      keyName,
      get(values, keyName).filter((_, index) => index !== i)
    );
    setFieldTouched(`${keyName}[${i}]`, false, false);
  };

  return (
    <Grid container item xs={12} columnSpacing={2} className="mt-2">
      <Grid item xs={12} sm={6} md={4}>
        <SelectField
          label={t("Accessories") + "*"}
          name={`${keyName}[${accessoriesIndex}].accessoryId`}
          formik={formik}
          disabled={isDisabled}
          options={accessoriesData || []}
          getOptionLabel={(option) => option?.name}
          getOptionValue={(option) => option?.id}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <SelectField
          label={t("Unit") + "*"}
          name={`${keyName}[${accessoriesIndex}].measurementTypeId`}
          disabled={isDisabled}
          formik={formik}
          getOptionValue={({ id }) => id}
          getOptionLabel={({ name }) => name}
          options={measurementTypes || []}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <InputFieldText
          formik={formik}
          label={t("Rate") + "*"}
          name={`${keyName}[${accessoriesIndex}].rate`}
          disabled={isDisabled}
          type="number"
          onChange={(e) => {
            setFieldValue(
              `${keyName}[${accessoriesIndex}].rate`,
              e.target.value
            );
            setFieldValue(
              `${keyName}[${accessoriesIndex}].finalCost`,
              e.target.value *
                get(values, `${keyName}[${accessoriesIndex}].quantity`)
            );
          }}
          placeholder="Enter Rate"
          InputProps={{
            inputProps: {
              min: 0,
              onKeyDown: (e) => onlyNumberKeys(e, true),
            },
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <InputFieldText
          formik={formik}
          placeholder="Enter Quantity"
          disabled={isDisabled}
          label={t("Quantity") + "*"}
          name={`${keyName}[${accessoriesIndex}].quantity`}
          type="number"
          onChange={(e) => {
            setFieldValue(
              `${keyName}[${accessoriesIndex}].quantity`,
              e.target.value
            );
            setFieldValue(
              `${keyName}[${accessoriesIndex}].finalCost`,
              e.target.value *
                get(values, `${keyName}[${accessoriesIndex}].rate`)
            );
          }}
          InputProps={{
            inputProps: {
              min: 0,
              onKeyDown: (e) => onlyNumberKeys(e, true),
            },
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <InputFieldText
          formik={formik}
          label={t("Amount")}
          name={`${keyName}[${accessoriesIndex}].finalCost`}
          type="number"
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Button
          color="error"
          size="small"
          sx={{
            minWidth: "unset",
            border: "1px solid",
            height: "40px",
            width: "100px",
          }}
          disabled={isDisabled}
          onClick={() => handleRemoveClick(accessoriesIndex)}
        >
          <strong className="d-flex justify-content-center">
            <DeleteOutlineSharpIcon fontSize="small" />
            {t("Remove")}
          </strong>
        </Button>
      </Grid>
    </Grid>
  );
};

RefundApplicationItem.propTypes = {
  t: PropTypes.func,
  keyName: PropTypes.string,
  accessoriesIndex: PropTypes.number,
  isDisabled: PropTypes.bool,
  formik: PropTypes.object,
};

export default withTranslation()(RefundApplicationItem);
